module.exports = __webpack_public_path__ + "files/21c7068dd26771b89d0057c35dc4e1f3.woff";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/lora-bold-webfont.woff
// module id = 692
// module chunks = 60